import React, { useEffect } from 'react'
import { useNode, useEditor } from '@craftjs/core'

/*

  a global wrapper for all cells in the layout
  mostly looking after CSS classes based on editor state

*/
export const RenderCell = ({ render }: {
  render: any,
}) => {
  const { actions, query } = useEditor()
  const {
    isActive,
    isHover,
    isDragging,
    applyMargin,
    dom,
  } = useNode((node) => {
    let applyMargin = false
    const parentNode = query.getState().nodes[node.data.parent]
    if(parentNode && parentNode.data.displayName == 'rowinner') {
      const childIds = parentNode.data.nodes || []
      const position = childIds.indexOf(node.id)
      if(position < childIds.length - 1) {
        applyMargin = true
      }
    }
    return {
      isActive: node.events.selected,
      isHover: node.events.hovered,
      isDragging: node.events.dragged,
      isCell: node.data.displayName == 'cell',
      dom: node.dom,
      applyMargin,
    }
  })

  // add the selected class to the active cell
  useEffect(() => {
    if (dom) {
      if (isActive) dom.classList.add('active')
      else dom.classList.remove('active')
      if(isHover) dom.classList.add('hover')
      else dom.classList.remove('hover')
    }
  }, [dom, isActive, isHover])

  useEffect(() => {
    if (dom) {
      if (applyMargin) dom.classList.add('Layout-Editor-Margin')
      else dom.classList.remove('Layout-Editor-Margin')
    }
  }, [dom, applyMargin])

  // if we are dragging a node - reset the selection
  useEffect(() => {
    if(isDragging && isActive) {
      actions.selectNode()
    }
  }, [
    isDragging,
  ])

  return (
    <>
      {render}
    </>
  )
}

export default RenderCell